import { Alert } from '@uhg-abyss/web/ui/Alert';
import { find } from 'lodash';

import { useLagoon } from '../../hooks/useLagoon';
import { ConstantsLagoon } from '../ConstantsLagoon';

export type Props = {
  onClose: () => void;
};

export const VisionSpecialistBanner = ({ onClose }: Props) => {
  const uiMessaging = useLagoon('ui-messaging')();

  const cta = find(uiMessaging, {
    key: ConstantsLagoon.UI_MESSAGING.VIEW_VISION_COVERAGE_CTA_URL,
  });

  const ctaUrl = cta?.url;
  const ctaMessage = cta?.message;

  const title = find(uiMessaging, {
    key: ConstantsLagoon.UI_MESSAGING.VISION_COVERAGE_ALERT_HEADER,
  })?.message;

  const description = find(uiMessaging, {
    key: ConstantsLagoon.UI_MESSAGING.VISION_COVERAGE_ALERT_DESCRIPTION,
  })?.message;

  return (
    <Alert
      cta={{
        type: 'link',
        props: {
          children: ctaMessage,
          onClick: () => {
            window.location.href = ctaUrl;
          },
        },
      }}
      data-testid="vision-specialist-banner"
      onClose={onClose}
      status="info"
      title={title}
    >
      {description}
    </Alert>
  );
};
